import DOMPurify from "dompurify";
import type { HTMLAttributes, Ref } from "react";

type SanitizedHtmlProps = Omit<
  HTMLAttributes<HTMLDivElement>,
  "dangerouslySetInnerHTML" | "children"
> & {
  html: string | null | undefined;
  ref?: Ref<HTMLDivElement>;
};

// Renders rich-text HTML (brief `additional_notes`, guide `content`) that
// reaches the client as markup. The server already scrubs these fields on the
// write boundary (Rarion::HtmlSanitizer); DOMPurify is defence-in-depth so a
// gap on either side can't turn stored HTML into stored XSS — critical in the
// client portal, which crosses the recruiter→client trust boundary. Prefer
// this over inline dangerouslySetInnerHTML at every raw-HTML render site so the
// sanitiser can never be forgotten. See security assessment finding H-2.
export function SanitizedHtml({ html, ...rest }: SanitizedHtmlProps) {
  return (
    <div
      {...rest}
      // biome-ignore lint/security/noDangerouslySetInnerHtml: sanitised via DOMPurify (here) + server-side allowlist scrubber (Rarion::HtmlSanitizer) on write
      dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(html ?? "") }}
    />
  );
}
